import script from "./InvestigationIncentiveReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationIncentiveReportTable.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationIncentiveReportTable.vue?vue&type=style&index=0&id=b2759d8a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2759d8a"]])

export default __exports__